import { render, staticRenderFns } from "./WomensDayLiveEvent.vue?vue&type=template&id=5ccb7c28"
import script from "./WomensDayLiveEvent.vue?vue&type=script&lang=js"
export * from "./WomensDayLiveEvent.vue?vue&type=script&lang=js"
import style0 from "./WomensDayLiveEvent.vue?vue&type=style&index=0&id=5ccb7c28&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports